var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form, message } from 'antd';
import { Select } from 'ui/styled';
import LabeledTooltip from '../LabeledTooltip';
var insuranceTierRules = function (member_id, insuranceSelected, isFacility) { return [
    {
        required: !!member_id,
        validator: function (rule, tier) {
            if (tier) {
                var _a = tier.split(','), _ = _a[0], kind = _a[1], uuid = _a[2];
                var isOutOfNetwork = kind === 'out_of_network' || kind === 'none';
                if (!isOutOfNetwork && uuid === 'null') {
                    message.error('It looks like this tier isn’t set up yet. Please reach out to your manager for help or select a different tier');
                    return Promise.reject();
                }
            }
            if (!tier && insuranceSelected) {
                return Promise.reject(new Error("Select Expected Tier To Attach This ".concat(isFacility ? 'Facility' : 'Doctor', ".")));
            }
            return Promise.resolve();
        }
    }
]; };
var InsuranceTier = function (_a) {
    var form = _a.form, member_id = _a.member_id, isFacility = _a.isFacility, loading = _a.loading, insuranceSelected = _a.insuranceSelected, plans = _a.plans, setIsOutOfNetworkSelected = _a.setIsOutOfNetworkSelected, tooltipText = _a.tooltipText;
    var plan = plans.find(function (i) { return i.id === insuranceSelected; });
    var benefitTiers = (plan === null || plan === void 0 ? void 0 : plan.insurance_tiers) || [];
    var defaultTier = (plan === null || plan === void 0 ? void 0 : plan.default_insurance_tier)
        ? [plan === null || plan === void 0 ? void 0 : plan.default_insurance_tier]
        : [];
    var tierOptions = __spreadArray(__spreadArray([], benefitTiers, true), defaultTier, true).map(function (_a) {
        var name = _a.name, kind = _a.kind, uuid = _a.uuid, id = _a.id;
        return ({
            value: "".concat(name, ",").concat(kind, ",").concat(uuid, ",").concat(id),
            key: id,
            label: name || 'Out-of-Network'
        });
    });
    return (_jsx(Form.Item, { name: "insurance_tier_id", rules: insuranceTierRules(member_id, insuranceSelected, isFacility), label: _jsx(LabeledTooltip, { label: "Expected Tier", tooltipText: tooltipText }), labelAlign: "left", colon: false, children: _jsx(Select, { placeholder: "Select Tier", loading: loading, disabled: !insuranceSelected, options: tierOptions, onChange: function (value) {
                var uuid = value.split(',')[2];
                setIsOutOfNetworkSelected(uuid === 'null');
                form.resetFields(['location_uuid']);
            } }) }));
};
export default InsuranceTier;
